<template>
  <div>
    <el-card>

      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="车辆编号" prop="bianhao" placeholder="请输入车辆编号">
          <el-input v-model="addForm.bianhao" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="车型选择" prop="chexing_uid">
          <cheXingSelect @getCarTypeSelectedUid="getCarTypeSelectedUid" :chexing_uid_props="addForm.chexing_uid" :key="datekey">
          </cheXingSelect>
        </el-form-item>
        <el-form-item label="车牌牌照" prop="paizhao">
          <el-input v-model="addForm.paizhao" :disabled="diaoyongType === 2 "></el-input>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-input v-model="addForm.color" ></el-input>
          <!-- <el-select v-model="addForm.color" placeholder="请选择车辆等级">
            <el-option v-for="item in color_options" :key="item.label" :label="item.label"
              :value="item.value"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="公里数" prop="gonglishu">
          <el-input v-model="addForm.gonglishu"    ></el-input>
       
        </el-form-item>
        <el-form-item label="外观" prop="waiguan">
          <el-select v-model="addForm.waiguan" placeholder="请选择车辆等级">
            <el-option v-for="item in waiguan_options" :key="item.label" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div style="text-align: center;" v-if="diaoyongType === 1">
        <el-button @click="quxiao">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import cheXingSelect from '../cheXing_select.vue'

export default {

  components: {
    cheXingSelect: cheXingSelect
  },
  props: ['paizhao', 'diaoyongType', 'caozuoType', 'editUid'], // diaoyongType 1 正常的界面管理调用 2 开单调用 editUid 如果有值，说明是修改
  data() {
    return {

      // 获取用户列表参数
      // addOrderForm: {
      //   cheliang_uid: 0,
      //   guest_uid: 0,
      //   waiguan_uid: 0,
      //   order_bianhao: '',
      //   order_money: 0,
      //   order_pay_flag: 0 
      // },
      datekey: Date.now(),
      addForm: {
        C_type: 'cheliang_add',
        bianhao: '',
        paizhao: '',
        color: '',
        waiguan: '',
        chexing_uid: 0,
        uid: 0,
        gonglishu: 0
      },
      waiguan_options: [
        {
          value: '很好',
          label: '很好'
        },
        {
          value: '良好',
          label: '良好'
        },
        {
          value: '一般',
          label: '一般'
        },
        {
          value: '很差',
          label: '很差'
        }
      ],
      color_options: [
        {
          value: '白色',
          label: '白色'
        },
        {
          value: 2,
          label: '黑色'
        },
        {
          value: '红色',
          label: '红色'
        },
        {
          value: '黄色',
          label: '黄色'
        },
        {
          value: '绿色',
          label: '绿色'
        }
      ],

      addFormRules: {
        paizhao: [
        { required: true, message: '请输入牌照', trigger: 'blur' },
        { min: 7, max: 8, message: '必须是6-7位字符! ', trigger: 'blur' }
        ],
        gonglishu: [
        { required: true, message: '请输入公里数', trigger: 'blur' } 
        ],
        chexing_uid: [
        { required: true, message: '请选择一个选项', trigger: 'change' }
        ]
      }

    }
  },
  created() {
    if (this.paizhao === undefined) this.addForm.paizhao = '苏J'
    else this.addForm.paizhao = this.paizhao
    if (this.caozuoType === 1) this.getBianhao_cheliang_add() // 说明是添加
    if (this.caozuoType === 2) this.Info(this.editUid)
    // this.datekey = Date.now()
  },

  methods: {
    quxiao() {
      if (this.diaoyongType === 1) this.$emit('getCheliangClose', this.Info)
    },
    getCarTypeSelectedUid(typeId) {
      console.log(880, typeId)
      this.addForm.chexing_uid = typeId
    },
    async getBianhao_cheliang_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 14 }
      });
      // console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.bianhao = JSON.parse(res.data)[0].bianhao_l;
    },
    async Info(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'cheliang_info', uid: uid, C_type: 'get_info' }
      });
      console.log(911, JSON.parse(res.data))
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }
      this.addForm = JSON.parse(res.data)[0].data[0];
      console.log('addForm', this.addForm)
    },

    add(callback) {
      var errFlag = 0
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
          errFlag = 1
          var data = {}
          if (this.diaoyongType === 2) callback(errFlag, data)
          return 1;
        }
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        var Info = {
          C_type: 'cheliang',
          bianhao: this.addForm.bianhao,
          paizhao: this.addForm.paizhao,
          color: this.addForm.color,
          waiguan: this.addForm.waiguan,
          chexing_uid: this.addForm.chexing_uid,
          uid: this.editUid,
          type: this.caozuoType,
          gonglishu: this.addForm.gonglishu
        }
        if (this.addForm.bianhao.length === 0) {
          this.$message.error('无编号，请重新递交');
           errFlag = 1
           callback(errFlag, Info) // 返回错误 uid 为 0
           return
        }
        console.log('chengxingUid', this.addForm.chexing_uid)
        if ((this.addForm.chexing_uid === 0) || (this.addForm.chexing_uid === undefined)) {
          this.$message.success('请选择车型！');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          return
        }
        console.log('cheliang_info', Info)
        const { data: res } = await this.$http.post('api', Info);
        console.log(90, JSON.parse(res.data)[0].status)
        if (JSON.parse(res.data)[0].status === 203) {
          this.$message.success('车辆重复！');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          return
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.success('添加出错');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          return
        }
        if (JSON.parse(res.data)[0].status === 200) this.$message.success('操作成功！');
        // 如果是添加，需要重新返回设置uid
        if (this.caozuoType === 1) Info.uid = JSON.parse(res.data)[0].cheliang_uid
         console.log('车辆添加返回信息', Info)
        if (this.diaoyongType === 1) this.$emit('getCheliangNewUid', Info)
        if (this.diaoyongType === 2) callback(errFlag, Info)
      });
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    }
  }
}
</script>../cheXing_selectB.vue
